import axios from 'axios';
import { OperadorSesion, LoginCredentials } from '../types/auth.types';

const STORAGE_KEY = 'caja_congreso_operador';

// Configurar interceptor para inyectar token en peticiones salientes
axios.interceptors.request.use((config) => {
  const operadorJson = localStorage.getItem(STORAGE_KEY);
  if (operadorJson) {
    try {
      const operador: OperadorSesion = JSON.parse(operadorJson);
      if (operador?.token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${operador.token}`;
      }
    } catch {
      // Ignorar error de parseo en interceptor
    }
  }
  return config;
});

export const authService = {
  getOperador: (): OperadorSesion | null => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  },

  setOperador: (sesion: OperadorSesion): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sesion));
  },

  clearOperador: (): void => {
    localStorage.removeItem(STORAGE_KEY);
  },

  isAuthenticated: (): boolean => {
    const op = authService.getOperador();
    return !!(op && op.token && op.usuario);
  },

  hasPermission: (permiso: string): boolean => {
    const op = authService.getOperador();
    if (!op || !op.permisos) return false;
    const target = permiso.toLowerCase();
    return op.permisos.some(p => {
      const lower = p.toLowerCase();
      return lower === target || lower === 'admin' || lower === '*' || lower === 'caja.web.*';
    });
  },

  getTipoEntidad: (): number => {
    const op = authService.getOperador();
    return op?.tipoEntidad ?? 1; // 1 = Caja por defecto
  },

  getCodigoColegio: (): string | null => {
    const op = authService.getOperador();
    return op?.codigoColegio ?? null;
  },

  login: async (credentials: LoginCredentials): Promise<OperadorSesion> => {
    if (!credentials.usuario?.trim() || !credentials.clave?.trim()) {
      throw new Error('Debe ingresar usuario y clave.');
    }

    try {
      const { data } = await axios.post<OperadorSesion>('/api/acreditacion/login', credentials);
      authService.setOperador(data);
      return data;
    } catch (err: any) {
      const mensaje = err?.response?.data?.message || err?.response?.data?.mensaje || err?.message || 'Credenciales inválidas. Verificá tus datos.';
      throw new Error(mensaje);
    }
  },

  logout: (): void => {
    authService.clearOperador();
  }
};
